import { render, staticRenderFns } from "./Widget14.vue?vue&type=template&id=54e04410"
import script from "./Widget14.vue?vue&type=script&lang=js"
export * from "./Widget14.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports